import MODULES from "@config/Modules/Shared/modules";

const getModuleName = (pathname: string): string =>
  Object.values(MODULES)
    .flat()
    .filter(({ route }) => pathname.includes(route))[0].name;
export default getModuleName;
